import Icon from '../components/Icon.vue'

Icon.register({"sort-desc":{"width":1024,"height":1792,"paths":[{"d":"M1024 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sort-desc.js
// module id = 1834
// module chunks = 0